const MONTH_SHORT_TEXT = [
  'січ',
  'лют',
  'бер',
  'кві',
  'тра',
  'чер',
  'лип',
  'сер',
  'вер',
  'жов',
  'лис',
  'гру',
];

export type MonthBar = {
  month: number;
  label: string;
  exactMinor: number;
  estimatedMinor: number;
  isChosen: boolean;
};

type MonthFigures = {
  month: number;
  exactMinor: number;
  estimatedMinor: number;
};

export const toMonthBars = (months: MonthFigures[], chosenMonth: number | null): MonthBar[] =>
  months.map((month) => ({
    month: month.month,
    label: MONTH_SHORT_TEXT[month.month - 1] ?? String(month.month),
    exactMinor: month.exactMinor,
    estimatedMinor: month.estimatedMinor,
    isChosen: month.month === chosenMonth,
  }));
